import React from 'react';
import { usePage } from '../contexts/pageContext';
import { useTranslate } from '../contexts/languageContext';
import { useNomenclator } from '../contexts/nomenclatorContext';
import styled from 'styled-components/macro';
import { responsive } from '../resources/constantes.json';
import { useEleccion } from '../contexts/eleccionContext';
import { fmt } from '../utils';

import BarraProgresoCircularStyled from '../components/BarraProgresoCircularStyled';
import Grafica from '../components/Grafica/Grafica';
import GraficaDonut from '../components/Grafica/Donut';
const InfoGeneral = () => {
  const pageState = usePage();
  const elecOpts = useEleccion();
  const t = useTranslate();
  const { data } = pageState;
  const nomenclator = useNomenclator();
  const info = data.totales.act;
  const zona15 = ['880030515', '880035515', '880038015'];
  const withOutExtra = zona15.includes(data.amb);
  let PmesasCorregido = '0';
  const Idconsultas = ['6', '8', '9'];
  if (withOutExtra && !Idconsultas.includes(elecOpts.idEleccion)) {
    PmesasCorregido =
      Math.floor((info.mesesc / (parseInt(info.metota) + 6)) * 10000) / 100 +
      '%';
  } else if (withOutExtra && Idconsultas.includes(elecOpts.idEleccion)) {
    PmesasCorregido =
      Math.floor(
        ((parseInt(info.mesesc) + 6) / (parseInt(info.metota) + 6)) * 10000
      ) /
        100 +
      '%';
  } else {
    PmesasCorregido = info.pmesesc;
  }
  const textoVotosCandidato = () => {
    if (Idconsultas.includes(elecOpts.idEleccion)) {
      return t('votosPartidosCandidatosConsulta');
    } else {
      return t('votosPartidosCandidatos');
    }
  };

  const showVotosBlanco = () => {
    return !Idconsultas.includes(elecOpts.idEleccion);
  };
  return (
    <MainContainer>
      <ContainerPrimeraSeccion>
        <ContainerListaGraficas>
          <ContainerGrafica>
            <div>
              <TitleSection>{t('mesasInf')}</TitleSection>
              <SubTitle>
                {fmt(info.mesesc)} de {fmt(info.metota)}
              </SubTitle>
            </div>
            <CajaGraficoDonut>
              <GraficaDonut value={info.pmesesc} color={'#1C4183'} name={t('mesasInf')} />
            </CajaGraficoDonut>
          </ContainerGrafica>
          <ContainerGrafica>
            <div>
              <TitleSection>{t('votantes')}</TitleSection>
              <SubTitle>
                {fmt(info.votant)} de {fmt(info.centota)}
              </SubTitle>
            </div>
            <CajaGraficoDonut>
              <GraficaDonut value={info.pvotant} color={'#EDB72A'} name={t('votantes')} />
            </CajaGraficoDonut>
          </ContainerGrafica>
        </ContainerListaGraficas>
        <SectionCamaras>
          {elecOpts.camaras.map((camara, index) => {
            const DatosCamara =
              nomenclator.nomAmbitos[elecOpts.idEleccion].cam[camara.cam];
            return (
              <ContainerDatos key={elecOpts.idEleccion + '_' + index}>
                {elecOpts.camaras.length > 0 && (
                  <>
                    <TitleSection>{t('votos')}</TitleSection>
                    {/*<NombreCamara>{DatosCamara.ca.toLowerCase()}</NombreCamara>
                    <LineaNombreCamara colorCamara={DatosCamara.co} />*/}
                  </>
                )}
                <CajaDatosGrafica>
                  <ContenedorFilas>
                    {/*<MiniBoxVotos>
                      <NombreBoxVotantes>
                        {t('votantes')}
                         <ColorDato colorCamara={DatosCamara.co} opacity={'1'} />
                        <ColorDato colorCamara={'grey'} opacity={'1'} />
                        <ColorDato colorCamara={'black'} opacity={'1'} /> 
                      </NombreBoxVotantes>
                      <VotosBox>{fmt(camara.totales.act.votant)}</VotosBox>
                      <PorcentajeBox>
                        {camara.totales.act.pvotant}
                      </PorcentajeBox>
                    </MiniBoxVotos>
                    */}
                    <MiniBoxVotos>
                      <NombreBoxTipos>
                        {/* <ColorDato colorCamara={'grey'} opacity={'1'} />{' '} */}
                        {t('noMarcados')}
                      </NombreBoxTipos>
                      <VotosBox>{fmt(camara.totales.act.votnma)}</VotosBox>
                      <PorcentajeBox>
                        {camara.totales.act.pvotnma}
                      </PorcentajeBox>
                    </MiniBoxVotos>
                    <MiniBoxVotos>
                      <NombreBoxTipos>
                        {/* <ColorDato colorCamara={'black'} opacity={'1'} />{' '} */}
                        {t('nulos')}
                      </NombreBoxTipos>
                      <VotosBox>{fmt(camara.totales.act.votnul)}</VotosBox>
                      <PorcentajeBox>
                        {camara.totales.act.pvotnul}
                      </PorcentajeBox>
                    </MiniBoxVotos>
                    <MiniBoxVotos>
                      <NombreBoxTipos>
                        {/* <ColorDato colorCamara={DatosCamara.co} opacity={'1'} />{' '} */}
                        {t('validos')}
                      </NombreBoxTipos>
                      <VotosBox>{fmt(camara.totales.act.votval)}</VotosBox>
                      <PorcentajeBox>
                        {camara.totales.act.pvotval}
                      </PorcentajeBox>
                    </MiniBoxVotos>
                    <MiniBoxVotos>
                      <NombreBoxValidos>
                        {/*  <ColorDato
                          colorCamara={DatosCamara.co}
                          opacity={'0.7'}
                        />{' '} */}
                        {textoVotosCandidato()}
                      </NombreBoxValidos>
                      <VotosBox>{fmt(camara.totales.act.votcan)}</VotosBox>
                      <PorcentajeBox>
                        {camara.totales.act.pvotcan}
                      </PorcentajeBox>
                    </MiniBoxVotos>
                    {showVotosBlanco() && (
                      <MiniBoxVotos>
                        <NombreBoxValidos>
                          {/* <ColorDato
                          colorCamara={DatosCamara.co}
                          opacity={'0.3'}
                        />{' '} */}
                          {t('enBlanco')}
                        </NombreBoxValidos>
                        <VotosBox>{fmt(camara.totales.act.votbla)}</VotosBox>
                        <PorcentajeBox>
                          {camara.totales.act.pvotbla}
                        </PorcentajeBox>
                      </MiniBoxVotos>
                    )}
                  </ContenedorFilas>
                  {/* <ContendorCajas>
                    <CajaGraficoValidos>
                      <BarraNoMarcado
                        color={'grey'}
                        height={camara.totales.act.pvotnma.replace(',', '.')}
                      />
                      <BarraNulos
                        color={'black'}
                        height={camara.totales.act.pvotnul.replace(',', '.')}
                      />
                      <BarraValidos
                        color={DatosCamara.co}
                        height={camara.totales.act.pvotval.replace(',', '.')}
                      />
                    </CajaGraficoValidos>
                    <CajaGrafico
                      height={camara.totales.act.pvotval.replace(',', '.')}
                    >
                      <BarraEnBlanco
                        color={DatosCamara.co}
                        height={camara.totales.act.pvotbla.replace(',', '.')}
                      />
                      <BarraAPartido
                        color={DatosCamara.co}
                        height={camara.totales.act.pvotcan.replace(',', '.')}
                      />
                    </CajaGrafico>
                  </ContendorCajas> */}
                </CajaDatosGrafica>
              </ContainerDatos>
            );
          })}
        </SectionCamaras>
      </ContainerPrimeraSeccion>
    </MainContainer>
  );
};

const CajaGraficoDonut = styled.div`
  height: 100%;
  width:  100%;
  margin: 20px 0px;
`;

const ContainerListaGraficas = styled.div`
	width: 66%;
	display: flex;
	justify-content: space-between;
	@media screen and (max-width: ${responsive.tablet}px) {
		width: 100%;
	}
	@media screen and (max-width: ${responsive.mobile}px) {
		width: 100%;
		flex-direction: column;
	}
`;

const ContainerGrafica = styled.div`
  width: 50%;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right:1px dashed #C4C4C4;
  @media screen and (max-width: ${responsive.tablet}px) {
    width: 100%;
    border-bottom:1px dashed #C4C4C4;
    :last-child{
      border-right:none;
    }
  }
  @media screen and (max-width: ${responsive.mobile}px) {
    border-right:none;
    border-bottom:1px dashed #C4C4C4;
  }
`;

const CajaDatosGrafica = styled.div`
  display: flex;
  justify-content: center;
	height: 100%;
	width: 100%;
	margin: 20px 0px;
`;

const ColorDato = styled(({ colorCamara, opacity, ...rest }) => (
  <div {...rest} />
))`
  width: 11px;
  height: 11px;
  background: ${({ colorCamara }) => colorCamara};
  opacity: ${({ opacity }) => opacity};
  border-radius: 6px;
  display: inline-block;
  margin-left: 1px;
`;

const ContainerDatos = styled.div`
  width: 95%;
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: space-between;
  @media screen and (max-width: ${responsive.mobile}px) {
    width: 100%;
  }
`;

const ContainerPrimeraSeccion = styled.div`
  display: flex;
  padding-bottom: 15px;
  justify-content: space-between;
  @media screen and (max-width: ${responsive.tablet}px) {
   flex-direction: column;
  }
}
`;

const LineaNombreCamara = styled(({ colorCamara, ...rest }) => (
  <div {...rest} />
))`
  border-bottom: 3px solid ${({ colorCamara }) => colorCamara};
  margin-bottom: 20px;
}
`;

const NombreCamara = styled.p`
  font-weight: 700;
  font-size: 22px;
  padding-bottom: 5px;
  :first-letter,
  :first-line {
    text-transform: capitalize;
  }
`;

const ContainerMesas = styled.div`
  width: 45%;
  justify-content: space-between;
  @media screen and (max-width: ${responsive.tablet}px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;

const ContainerTextoMesas = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ContainerVotantes = styled.div`
  width: 45%;
  @media screen and (max-width: ${responsive.tablet}px) {
    width: 100%;
  }
`;

const ContainerTextoVotantes = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TitleSection = styled.p`
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 43px;
  letter-spacing: 0em;
  text-align: left;
  color: #172946;
	text-transform: capitalize;
`;

const SubTitle = styled.span`
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: left;
  color: #333333;
`;

const NombreBoxVotantes = styled.div`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  width: 40%;
  text-transform: uppercase;
  @media screen and (max-width: ${responsive.tablet}px) {
    font-size: 13px;
  }
`;

const NombreBoxTipos = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  width: 38%;
  margin-left: 2%;
	text-transform: capitalize;
  @media screen and (max-width: ${responsive.tablet}px) {
    font-size: 15px;
		text-align: center;
  }
`;

const NombreBoxValidos = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  width: 34%;
  margin-left: 6%;
	text-transform: capitalize;
  @media screen and (max-width: ${responsive.tablet}px) {
    font-size: 15px;
		text-align: center;
  }
`;

const VotosBox = styled.div`
  font-weight: 300;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: center;
  width: 34%;
  @media screen and (max-width: ${responsive.tablet}px) {
    font-size: 15px;
		text-align: center;
  }
`;

const PorcentajeBox = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  font-weight: 700;
  width: 26%;
  @media screen and (max-width: ${responsive.tablet}px) {
    font-size: 15px;
		text-align: center;
  }
`;

const SectionCamaras = styled.div`
  width: 33%;
  display: flex;
  justify-content: center;
  @media screen and (max-width: ${responsive.tablet}px) {
    width: 100%;
    justify-content: center;
    margin: 5% 0px;
  }
`;

const MainContainer = styled.div`
  padding: 15px;
`;

const ContainerCamara = styled.div`
  width: 33%;
  display: flex;
  @media screen and (max-width: ${responsive.tablet}px) {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 40px;
  }
`;

const MiniBoxVotos = styled.div`
  width: 100%;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;

const TitleCamara = styled.p`
  font-size: 18px;
  :first-letter,
  :first-line {
    text-transform: capitalize;
  }
`;

const BarraValidos = styled(({ color, height, ...rest }) => <span {...rest} />)`
  width: 10px;
  opacity: 1;
  background-color: ${({ color }) => color};
  height: ${({ height }) => height};
  transition-timing-function: linear;
  transition: height 1s ease-in-out;
`;

const BarraNoMarcado = styled(({ color, height, ...rest }) => (
  <span {...rest} />
))`
  width: 10px;
  background-color: ${({ color }) => color};
  height: ${({ height }) => height};
  transition-timing-function: linear;
  transition: height 1s ease-in-out;
`;

const BarraNulos = styled(({ color, height, ...rest }) => <span {...rest} />)`
  width: 10px;
  background-color: ${({ color }) => color};
  height: ${({ height }) => height};
  transition-timing-function: linear;
  transition: height 1s ease-in-out;
`;

const BarraAPartido = styled(({ color, height, ...rest }) => (
  <span {...rest} />
))`
  width: 10px;
  opacity: 0.7;
  background-color: ${({ color }) => color};
  height: ${({ height }) => height};
  transition-timing-function: linear;
  transition: height 1s ease-in-out;
`;

const BarraEnBlanco = styled(({ color, height, ...rest }) => (
  <span {...rest} />
))`
  width: 10px;
  opacity: 0.3;
  background-color: ${({ color }) => color};
  height: ${({ height }) => height};
  transition-timing-function: linear;
  transition: height 1s ease-in-out;
`;

const CajaGrafico = styled(({ height, ...rest }) => <div {...rest} />)`
  width: 10px;
  max-width: 100px;
  display: flex;
  justify-content: flex-end;
  height: ${({ height }) => height};
  flex-direction: column;
  background-color: #e0e0e0;
  box-sizing: border-box;
`;

const CajaGraficoValidos = styled.div`
  width: 10px;
  max-width: 100px;
  display: flex;
  justify-content: flex-end;
  height: 100%;
  flex-direction: column;
  background-color: #e0e0e0;
  box-sizing: border-box;

  margin-right: 10px;
`;

const ContendorCajas = styled.div`
  display: flex;
  align-items: flex-end;
  height: 265px;
`;
const ContenedorFilas = styled.div`
  width: 90%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

const CajaGraficoHorizontal = styled(({ height, color, ...rest }) => (
  <div {...rest} />
))`
  height: 30px;
  display: flex;
  position: relative;
  justify-content: flex-end;
  border-bottom: 5px solid rgba(255, 255, 255, 0.7);
  width: 100%;
  flex-direction: column;
  background-color: ${({ color }) => color};
  box-sizing: border-box;
`;

const BarraHorizontal = styled(({ color, width, ...rest }) => (
  <span {...rest} />
))`
  position: absolute;
  transition: width 1s ease-in-out;
  top: 0;
  height: 25px;
  border-bottom: 5px solid rgba(255, 255, 255, 0.7);
  opacity: 1;
  background-color: ${({ color }) => color};
  width: ${({ width }) => width};
  transition-timing-function: linear;
`;

export default InfoGeneral;
